var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ag-loading" },
    [
      _c("ag-icon", {
        staticClass: "ag-loading__animate",
        attrs: {
          icon: "loading",
          size: _vm.size,
          fill: "currentColor",
          stroke: "none",
        },
      }),
      _vm._v(" "),
      _c("p", { style: { fontSize: _vm.fontSize + "px" } }, [
        _vm._v("\n    " + _vm._s(_vm.text) + "\n  "),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }